import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import MyPagination from "~/cabinet/vue/interface/pagination/MyPagination.vue";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";


const __default__ = {
    name: "ReactiveRequestPagination"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    listRequest: {}
  },
  setup(__props: any) {

let props = __props;

function make(page: number, onPage?: number) {
    props.listRequest.make(page, onPage);
}

return (_ctx: any,_cache: any) => {
  return (__props.listRequest.data)
    ? (_openBlock(), _createBlock(MyPagination, {
        key: 0,
        "fetch-result": __props.listRequest.data,
        onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (make($event))),
        onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (make(0, $event)))
      }, null, 8, ["fetch-result"]))
    : _createCommentVNode("", true)
}
}

})